import { useMutation } from '@apollo/client'
import { useCallback } from 'react'
import {
  CreateAudienceMemberV2Mutation,
  CreateAudienceMemberV2MutationVariables
} from '../../data/gql-gen/questionnaire/graphql'
import { CREATE_AUDIENCE_MEMBER_V2 } from '../../data/gql/questionnaire/mutations/createAudienceMemberV2'
import { draftAudienceRefetchQuery } from '../../data/gql/questionnaire/queries/audiences'
import { categoriesRefetchQuery } from '../../data/gql/questionnaire/queries/categories'
import { customCriteriaRefetchQuery } from '../../data/gql/questionnaire/queries/customCriteria'
import { LoggerErrorType } from '../../data/logger'
import { captureApolloError } from '../../utils/HelperFunctions'
import { useOptionalWaveId } from '../useOptionalWaveId'
import { useProjectId } from '../useProjectId'
import { useSurveyId } from '../useSurveyId'

export const useCreateAudienceMemberV2 = () => {
  const projectId = useProjectId()
  const surveyId = useSurveyId()
  const waveId = useOptionalWaveId()

  const [createAudienceMemberV2] = useMutation<
    CreateAudienceMemberV2Mutation,
    CreateAudienceMemberV2MutationVariables
  >(CREATE_AUDIENCE_MEMBER_V2, {
    context: { clientName: 'questionnaire' },
    onError(error) {
      captureApolloError(
        LoggerErrorType.ApolloMutation,
        'createAudienceMemberV2',
        error
      )
    },
    refetchQueries: [
      draftAudienceRefetchQuery(projectId, surveyId, waveId),
      customCriteriaRefetchQuery(projectId, surveyId, waveId),
      categoriesRefetchQuery(projectId, surveyId, waveId)
    ]
  })

  return useCallback(
    (options: Parameters<typeof createAudienceMemberV2>[0]) =>
      createAudienceMemberV2({
        ...options,
        variables: options?.variables && {
          ...options.variables,
          input: { ...options.variables.input, waveId }
        }
      }),
    [createAudienceMemberV2, waveId]
  )
}
